/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */

// Maybe we will have to convert it to vuex store, will find out if data is stateless
function dashboardDataSource() {
  const methods = {
    airportSequence: null,
    flightRules: {},
    routeMap: {},
    fullData: {},
  };
  methods.getFlightRule = () => methods.flightRules;
  methods.setFlightRule = (rules) => {
    methods.flightRules = rules;
  };
  methods.setAirportSequence = (airportSequence) => {
    methods.airportSequence = airportSequence;
  };
  methods.setRouteMap = (routeMap) => {
    methods.routeMap = routeMap;
  };
  methods.setFullData = (fullData) => {
    // This object contains MAV and LAMP mode data
    methods.fullData = fullData;
  };
  methods.cleanFactory = () => {
    methods.data = null;
    methods.airportSequence = null;
    methods.processed = false;
    methods.flightRules = {};
    methods.routeMap = {};
    methods.fullData = {};
  };
  return methods;
}
export default dashboardDataSource();
